<template>
  <div>
    <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-6 lg:gap-12">
      <div class="flex-1">
        <div v-if="$slots['secondary-title']" class="text-xl text-[#666666]">
          <slot name="secondary-title" />
        </div>
        <div class="flex space-x-4 items-center">
          <DsfrHeading as="h1" size="2xl" :aria-live="ariaLive">
            {{ title }}
          </DsfrHeading>
          <LoadingIndicator v-if="loading" />
        </div>

        <slot name="tags" />

        <h2 v-if="$slots['secondary-title-bottom']" class="text-[#666666] mt-2 text-lg lg:text-xl">
          <slot name="secondary-title-bottom" />
        </h2>
      </div>
      <slot name="action" />
    </div>
    <slot name="bottom" />
  </div>
</template>

<script>
import LoadingIndicator from '@/components/custom/LoadingIndicator.vue'

export default defineNuxtComponent({
  components: {
    LoadingIndicator,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    ariaLive: {
      type: String,
      default: null,
    },
  },
})
</script>
